// extracted by mini-css-extract-plugin
export default {"wrapper":"Adults-module__wrapper___TmtWf"};